<div mat-dialog-container>
  <div class="mat-dialog-header-content">
    <mat-icon class="{{'icon ' + data.messageType + '-icon'}}">{{icons[data.messageType].icon}}</mat-icon>
  </div>
  <div class="mat-dialog-header-content">
    <h1>{{data.messageTitle}}</h1>
  </div>
  <mat-dialog-content>
    <mat-card class="dialog-content" *ngIf="data.messageContent">
      <!-- {{data.messageContent}} -->
      <div [innerHTML]="data.messageContent"></div>
    </mat-card>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-flat-button *ngIf="data.messageType === 'question' || data.messageType === 'warning'" color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{'MENU_CARD.ACCEPT'|translate}}</button>
    <button mat-flat-button *ngIf="data.messageType === 'question' || data.messageType === 'warning'" color="accent" [mat-dialog-close]="false" (click)="closeMe()">{{'MENU_CARD.CANCEL'|translate}}</button>
    <button mat-flat-button *ngIf="data.messageType !== 'question' && data.messageType !== 'warning'" color="primary" [mat-dialog-close]="true" (click)="closeMe()">{{'MENU_CARD.CLOSE'|translate}}</button>
  </div>
</div>
